import { createTheme } from '@mui/material/styles';
import accordion from './accordion';
import autocomplete from './autocomplete';
import baseTheme from './base';
import button from './button';
import calendar from './calendar';
import chip from './chip';
import datagrid from './datagrid';
import datePicker from './datePicker';
import dialog from './dialog';
import form from './form';
import icon from './icon';
import input from './input';
import link from './link';
import list from './list';
import menu from './menu';
import slider from './slider';
import switchTheme from './switch';
import tabs from './tabs';
import tooltip from './tooltip';

const theme = createTheme(baseTheme, {
  components: {
    MuiCssBaseline: {
      styleOverrides: (t: Theme) => ({
        // Firefox
        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor: `${t.palette.grey[400]} transparent`,
        },

        // Chrome / Safari / Edge
        '*::-webkit-scrollbar': {
          width: 8,
          height: 8,
        },
        '*::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: t.palette.grey[400],
          borderRadius: 8,
          border: '2px solid transparent',
          backgroundClip: 'content-box',
        },
        '*::-webkit-scrollbar-thumb:hover': {
          backgroundColor: t.palette.grey[500],
        },
      }),
    },
    ...accordion,
    ...autocomplete,
    // ...layout(base),
    ...input,
    // ...select,
    ...button,
    ...list,
    ...form,
    // ...table,
    ...menu,
    // ...alerts,
    ...tabs,
    // ...toggles,
    ...dialog,
    // ...pagination,
    ...tooltip,
    ...datagrid,
    // ...loader,
    ...link,
    ...datePicker,
    ...calendar,
    ...icon,
    ...chip,
    ...slider,
    ...switchTheme,
  },
});
export type Theme = typeof theme;
export default theme;
